import { api } from "./api";
import * as endpoints from "../data/links/endpoints";

export async function getCountries({ signal }) {
  return api
    .get(endpoints.GET_COUNTRIES, { signal })
    .then((res) => res.data.countries)
    .catch((error) => error.response);
}

export async function getWorkoutTypes({ signal }) {
  return api
    .get(endpoints.GET_WORKOUT_TYPES, { signal })
    .then((res) => res.data.types)
    .catch((error) => error.response);
}

export async function getExerciseCategories({ signal, wodable }) {
  return api
    .get(endpoints.EXERCISE_CATEGORIES + wodable, { signal })
    .then((res) => res.data.categories)
    .catch((error) => error.response);
}

export async function getWorkoutStructures({ signal }) {
  return api
    .get(endpoints.GET_WORKOUT_STRUCTURES, { signal })
    .then((res) => res.data.structures)
    .catch((error) => error.response);
}

export async function getWeights({ signal }) {
  return api
    .get(endpoints.GET_WEIGHTS, { signal })
    .then((res) => res.data.weights)
    .catch((error) => error.response);
}

export async function getAchievements({ signal }) {
  return api
    .get(endpoints.GET_ACHIEVEMENTS, { signal })
    .then((res) => res.data.achievements)
    .catch((error) => error.response);
}

export async function getPresignedUrl(data) {
  return api.post(endpoints.GET_PRESIGNED_URL, data).then((res) => res);
}

export async function confirmUploadFile(data) {
  return api.post(endpoints.CONFIRM_UPLOAD, data).then((res) => res);
}
